var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16C3 8.82 8.82 3 16 3C23.18 3 29 8.82 29 16C29 23.18 23.18 29 16 29C8.82 29 3 23.18 3 16ZM11.1973 19.404C11.1189 19.5095 11.062 19.6294 11.0299 19.7568C10.9979 19.8843 10.9912 20.0168 11.0104 20.1468C11.0296 20.2769 11.0743 20.4018 11.1418 20.5146C11.2093 20.6274 11.2984 20.7257 11.404 20.804C12.7314 21.7953 14.3433 22.3317 16 22.3333C17.6569 22.3313 19.2688 21.7945 20.596 20.8027C20.8022 20.6422 20.9374 20.4074 20.9727 20.1485C21.008 19.8895 20.9405 19.6271 20.7847 19.4173C20.629 19.2075 20.3973 19.067 20.1392 19.0259C19.8812 18.9848 19.6173 19.0463 19.404 19.1973C18.4215 19.933 17.2275 20.3315 16 20.3333C14.7725 20.3315 13.5785 19.933 12.596 19.1973C12.4905 19.1189 12.3706 19.062 12.2432 19.0299C12.1157 18.9979 11.9832 18.9912 11.8532 19.0104C11.7231 19.0296 11.5982 19.0743 11.4854 19.1418C11.3726 19.2093 11.2756 19.2984 11.1973 19.404ZM20.3333 13.3333C20.3333 13.0681 20.228 12.8138 20.0404 12.6262C19.8529 12.4387 19.5986 12.3333 19.3333 12.3333C19.0681 12.3333 18.8138 12.4387 18.6262 12.6262C18.4387 12.8138 18.3333 13.0681 18.3333 13.3333V14C18.3333 14.2652 18.4387 14.5196 18.6262 14.7071C18.8138 14.8946 19.0681 15 19.3333 15C19.5986 15 19.8529 14.8946 20.0404 14.7071C20.228 14.5196 20.3333 14.2652 20.3333 14V13.3333ZM12.6667 12.3333C12.4015 12.3333 12.1471 12.4387 11.9596 12.6262C11.772 12.8138 11.6667 13.0681 11.6667 13.3333V14C11.6667 14.2652 11.772 14.5196 11.9596 14.7071C12.1471 14.8946 12.4015 15 12.6667 15C12.9319 15 13.1862 14.8946 13.3738 14.7071C13.5613 14.5196 13.6667 14.2652 13.6667 14V13.3333C13.6667 13.0681 13.5613 12.8138 13.3738 12.6262C13.1862 12.4387 12.9319 12.3333 12.6667 12.3333Z",
    fill: "url(#paint0_linear_4684_37183)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4684_37183",
    x1: 2.98442,
    y1: 26.3631,
    x2: 35.4861,
    y2: 14.4324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95C843"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.0110e7fc938bbbe5886a4fdea6a98b36.svg";
export { ForwardRef as ReactComponent };